import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/IcosahedronGeometry'

export default meshComponent('Icosahedron', props, createGeometry)
